// material
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField
} from '@material-ui/core';
import { Autocomplete, DateRange, DateRangePicker, LocalizationProvider } from '@material-ui/lab';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useEffect, useState } from 'react';
import { Block } from '../../Block';
// ----------------------------------------------------------------------

export default function PickerDateRange({ callback, title, currencySelector, sentCompanies }: any) {
  const [value, setValue] = useState<DateRange<Date>>([null, null]);
  const [currency, setCurrency] = useState<string>('NOK');
  const [companies, setCompanies] = useState<string[]>(sentCompanies);
  const [company, setCompany] = useState<string>('');

  useEffect(() => {
    setCompanies(sentCompanies);
  }, [sentCompanies, companies]);
  return (
    <Stack spacing={3} direction={{ xs: 'column', md: 'row' }} style={{ marginBottom: '2em' }}>
      <Stack spacing={3} sx={{ width: 1 }}>
        <Block title={title}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateRangePicker
              startText="Start date (inclusive)"
              endText="Stop date (inclusive)"
              value={value}
              onChange={(newValue) => {
                setValue(newValue);
              }}
              renderInput={(startProps, endProps) => (
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                  <TextField {...startProps} />
                  <Box>to</Box>
                  <TextField {...endProps} />
                  {currencySelector ? (
                    <FormControl sx={{ minWidth: 80 }}>
                      <InputLabel id="currency">Currency</InputLabel>
                      <Select
                        labelId="currency-selector"
                        id="currency-selector"
                        value={currency}
                        label="Currency"
                        onChange={(e) => {
                          setCurrency(e.target.value);
                          e.preventDefault();
                        }}
                      >
                        <MenuItem value="NOK">NOK</MenuItem>
                        <MenuItem value="SEK">SEK</MenuItem>
                        <MenuItem value="DKK">DKK</MenuItem>
                        <MenuItem value="EUR">EUR</MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    ''
                  )}
                  {companies.length > 0 ? (
                    <Autocomplete
                      sx={{ minWidth: 220 }}
                      options={companies}
                      value={company || null}
                      onChange={(_event, newValue) => setCompany(newValue ?? '')}
                      autoHighlight
                      renderInput={(params) => <TextField {...params} label="Company" />}
                    />
                  ) : (
                    ''
                  )}
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                      callback(value, currency, company);
                    }}
                  >
                    Search for report
                  </Button>
                </Box>
              )}
            />
          </LocalizationProvider>
        </Block>
      </Stack>
    </Stack>
  );
}
